import { lazy, Suspense } from 'react';

const LazyVerifyComplete = lazy(() => import('./VerifyComplete'));

const VerifyComplete = () => (
  <Suspense fallback={null}>
    <LazyVerifyComplete />
  </Suspense>
);

export default VerifyComplete;
